export const matchNavPath = (current: string, navPath: string): boolean => {
  const normalize = (p: string) =>
    p.length > 1 && p.endsWith('/') ? p.slice(0, -1) : p;

  const cur = normalize(current);
  const nav = normalize(navPath);

  if (nav.endsWith('/*')) {
    const base = nav.slice(0, -2);
    return cur === base || cur.startsWith(`${base}/`);
  }

  const curParts = cur.split('/');
  const navParts = nav.split('/');
  if (curParts.length !== navParts.length) return false;
  for (let i = 0; i < navParts.length; i++) {
    const n = navParts[i],
      c = curParts[i];
    if (n.startsWith(':')) continue;
    if (n !== c) return false;
  }
  return true;
};
